
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_4zbxd_97",
  "tools": "awsui_tools_wih1l_4zbxd_106",
  "tools-filtering": "awsui_tools-filtering_wih1l_4zbxd_112",
  "tools-align-right": "awsui_tools-align-right_wih1l_4zbxd_116",
  "tools-pagination": "awsui_tools-pagination_wih1l_4zbxd_120",
  "tools-preferences": "awsui_tools-preferences_wih1l_4zbxd_120",
  "tools-small": "awsui_tools-small_wih1l_4zbxd_126",
  "table": "awsui_table_wih1l_4zbxd_132",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_4zbxd_138",
  "wrapper": "awsui_wrapper_wih1l_4zbxd_142",
  "variant-stacked": "awsui_variant-stacked_wih1l_4zbxd_152",
  "variant-container": "awsui_variant-container_wih1l_4zbxd_152",
  "variant-embedded": "awsui_variant-embedded_wih1l_4zbxd_156",
  "has-header": "awsui_has-header_wih1l_4zbxd_159",
  "has-footer": "awsui_has-footer_wih1l_4zbxd_162",
  "cell-merged": "awsui_cell-merged_wih1l_4zbxd_172",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_4zbxd_176",
  "empty": "awsui_empty_wih1l_4zbxd_191",
  "loading": "awsui_loading_wih1l_4zbxd_195",
  "selection-control": "awsui_selection-control_wih1l_4zbxd_199",
  "selection-control-header": "awsui_selection-control-header_wih1l_4zbxd_206",
  "sticky-scrollbar": "awsui_sticky-scrollbar_wih1l_4zbxd_211",
  "sticky-scrollbar-content": "awsui_sticky-scrollbar-content_wih1l_4zbxd_221",
  "sticky-scrollbar-visible": "awsui_sticky-scrollbar-visible_wih1l_4zbxd_224",
  "header-secondary": "awsui_header-secondary_wih1l_4zbxd_228",
  "header-controls": "awsui_header-controls_wih1l_4zbxd_248",
  "divider": "awsui_divider_wih1l_4zbxd_265",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_4zbxd_272",
  "footer": "awsui_footer_wih1l_4zbxd_272",
  "thead-active": "awsui_thead-active_wih1l_4zbxd_281",
  "row": "awsui_row_wih1l_4zbxd_282",
  "row-selected": "awsui_row-selected_wih1l_4zbxd_283"
};
  